import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row justify-center q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")
  const _component_answer_button = _resolveComponent("answer-button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_message_wrap, {
      isShowMessageTail: _ctx.isShowMessageTail,
      message: _ctx.message,
      avatar: _ctx.avatar,
      onInit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('init')))
    }, {
      default: _withCtx(() => [
        _createVNode("span", {
          textContent: _toDisplayString(_ctx.message.text)
        }, null, 8, ["textContent"])
      ]),
      _: 1
    }, 8, ["isShowMessageTail", "message", "avatar"]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_answer_button, {
          key: index,
          button: button,
          onClickButtonWithPayload: _ctx.addGeo,
          style: { ..._ctx.CalculaterButtonWidth(button.width) }
        }, null, 8, ["button", "onClickButtonWithPayload", "style"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
}